import Callout from "ds/components/Callout";

const NegativeRunInfo = () => {
  return <Callout variant="warning">This module test run is explicitly expected to fail.</Callout>;
};

export default NegativeRunInfo;
